export const ui = {
  it: {
    pageTitle: 'Arengo — Memoria viva',
    skip: 'Vai al contenuto',
    wordmarkLabel: 'Arengo — Memoria viva — torna all’inizio',
    languageLabel: 'Lingua del sito',
    menuToggle: 'Apri o chiudi il menu',
    navLabel: 'Navigazione principale',
    nav: ['Storia', 'Fotografie', '12 richieste', 'Il cammino', 'Archivio'],
    accessibility: 'Accessibilità',
    readingPreferences: 'Preferenze di lettura',
    closeAccessibility: 'Chiudi il pannello accessibilità',
    accessibilityIntro: 'Adatta la pagina alle tue esigenze. Le preferenze restano su questo dispositivo.',
    highContrast: 'Contrasto elevato',
    largeText: 'Testo più grande',
    reducedMotion: 'Riduci animazioni',
    active: 'Attivo',
    inactive: 'Non attivo',
    reset: 'Ripristina le impostazioni',
    heroDate: '21 febbraio 2021',
    heroTitleStart: 'Questa luce',
    heroTitleMiddle: 'racconta',
    heroTitleEnd: 'una storia.',
    heroLead: 'L’Arengo delle famiglie di persone con disabilità: una giornata storica, dodici richieste, una stele che oggi torna visibile.',
    enterStory: 'Entra nella storia',
    watchVideo: 'Guarda il video',
    heroAlt: 'Cittadini e famiglie riuniti davanti alla Basilica del Santo per l’Arengo del 21 febbraio 2021',
    heroCaption: 'Piazzale Domus Plebis, 21 febbraio 2021',
    scroll: 'Scorri per scoprire',
    chapterMemory: 'Memoria',
    memory: 'La memoria',
    historyTitle: 'Una pagina nella storia di San Marino',
    historyLead: 'Il 21 febbraio 2021, nel Piazzale Domus Plebis, famiglie, associazioni e cittadinanza si riunirono per chiedere che i diritti riconosciuti diventassero diritti vissuti.',
    whyArengo: 'Perché chiamarlo Arengo',
    whyArengoText: 'Il riferimento è all’Arengo dei capifamiglia del 25 marzo 1906, quando una scelta collettiva impresse una svolta democratica alla Repubblica. Nel 2021 quel nome è tornato per affermare uguaglianza, partecipazione e dignità.',
    pandemicLabel: 'In piena pandemia',
    pandemicQuote: 'In lockdown da una vita',
    pandemicText: 'L’Arengo si tenne nel febbraio 2021, durante l’emergenza COVID-19: mascherine, distanziamento e restrizioni rendevano ancora più forte il valore di quella presenza collettiva.',
    pandemicNote: 'La frase esposta su uno striscione univa il presente della pandemia alla denuncia di un’esclusione vissuta da molto più tempo.',
    historicNumbersLabel: 'Dati dell’Arengo dei capifamiglia del 1906',
    households: 'capifamiglia convocati',
    favourable: 'favorevoli',
    photoDate: '21 febbraio 2021',
    photoTitle: 'Una giornata\nscritta insieme.',
    photoLead: 'Volti, gesti e voci dell’Arengo.',
    photoQuote: '“L’incontro, l’entusiasmo, l’ascolto, la partecipazione, la solidarietà… potremmo definirli ottimi vaccini e/o anticorpi contro l’indifferenza.”',
    photoQuoteSource: 'Dal discorso di Attiva-Mente',
    explorePhotos: 'Esplora le fotografie',
    photoArchiveNote: 'Sette fotografie selezionate dall’archivio originale di Attiva-Mente.',
    enlargePhoto: 'Ingrandisci la fotografia',
    closePhotos: 'Chiudi la galleria fotografica',
    previousPhoto: 'Fotografia precedente',
    nextPhoto: 'Fotografia successiva',
    photoArchive: 'Archivio fotografico',
    documentLabel: 'Il documento',
    requestsTitle: 'Dodici richieste. Un solo principio: pari dignità.',
    requestsLead: 'Il documento consegnato alla Reggenza tradusse la partecipazione in impegni concreti.',
    requestsIndex: 'Indice delle dodici richieste',
    previous: 'Precedente',
    next: 'Successiva',
    of: 'di',
    previousRequest: 'Richiesta precedente',
    nextRequest: 'Richiesta successiva',
    motto: '“Nulla su di noi senza di noi.”',
    readOriginal: 'Leggi il documento originale',
    requestAlt: 'La stele dell’Arengo accanto alla bandiera della Repubblica di San Marino',
    requestCaption: 'La partecipazione diventa richiesta concreta.',
    timelineLabel: 'Il cammino della stele',
    timelineTitle: 'Dalla voce alla pietra.\nDalla pietra alla luce.',
    timeline2021Title: 'L’Arengo',
    timeline2021Text: 'In piena pandemia COVID-19, tra mascherine e distanziamento, famiglie, associazioni e cittadini si riuniscono davanti alla Basilica per rivendicare diritti, partecipazione e pari opportunità.',
    timeline2021Alt: 'L’Arengo davanti alla Basilica del Santo nel 2021',
    timeline2023Title: 'La stele trova casa',
    timeline2023Text: 'Il 15 marzo la memoria dell’Arengo viene collocata in un luogo permanente, trasformando il ricordo di una giornata in un segno pubblico.',
    timeline2023Alt: 'Lo svelamento della stele sotto la pioggia nel marzo 2023',
    timeline2026Title: 'Una luce accesa',
    timeline2026Text: 'Un punto luce rende finalmente visibile la stele anche di sera e restituisce dignità al simbolo.',
    timeline2026Link: 'Leggi la notizia dell’illuminazione',
    timeline2026Alt: 'La stele illuminata nelle ore serali nel 2026',
    pressLabel: 'Le pagine dell’epoca',
    pressTitle: 'L’Arengo visto dalla stampa.',
    pressLead: 'Otto testimonianze dell’attenzione pubblica suscitata dall’iniziativa. Seleziona una pagina per leggerla nelle dimensioni originali.',
    openEnlarge: 'Apri e ingrandisci',
    explorePage: 'Esplora la pagina',
    closePress: 'Chiudi la rassegna stampa',
    previousPage: 'Pagina precedente',
    nextPage: 'Pagina successiva',
    openOriginal: 'Apri l’originale',
    archiveLabel: 'Archivio vivo',
    archiveTitle: 'Guarda, ascolta, approfondisci.',
    archiveLead: 'L’Arengo vive nelle voci, nelle immagini e nei documenti di chi lo ha costruito.',
    videoFallback: 'Il tuo browser non supporta il video.',
    videoLabel: 'Il racconto video',
    videoTitle: 'Arengo delle famiglie di persone con disabilità',
    transcriptTitle: 'Contesto e sintesi dell’iniziativa',
    transcript1: 'L’iniziativa si apre con il saluto degli organizzatori e gli interventi delle realtà aderenti, prosegue con la celebrazione nella Basilica e si conclude con la lettura delle dodici richieste, l’accompagnamento musicale e lo svelamento della stele.',
    transcript2: 'Il messaggio centrale è netto: i diritti già riconosciuti devono diventare pienamente esigibili, con il coinvolgimento diretto delle persone con disabilità nelle decisioni che le riguardano.',
    originalDocuments: 'Documenti originali',
    originalItalian: 'originale in italiano',
    pressArchiveLabel: 'Rassegna stampa',
    pressArchiveTitle: 'Le pagine che raccontarono l’Arengo',
    pressImageAlt: 'Pagina de La Serenissima del 22 febbraio 2021 dedicata all’Arengo',
    pressPdf: 'Apri il PDF de La Serenissima',
    closingLabel: 'Una memoria che resta visibile',
    closingTitle: 'I diritti non devono mai rimanere nell’ombra.',
    closingLead: 'Illuminare questa stele significa custodire la memoria dell’Arengo, delle famiglie e di una comunità che ha scelto di partecipare.',
    closingLine: 'Anche una luce può raccontare una storia.',
    discover: 'Scopri Attiva-Mente',
    backTop: 'Torna all’inizio',
    thanks: 'Grazie a chi ha reso possibile il punto luce e a tutte le persone che continuano a difendere questa memoria.',
    closingAlt: 'La comunità riunita davanti alla Basilica del Santo con lo striscione contro l’indifferenza',
    closingCaption: 'La comunità davanti alla Basilica, 21 febbraio 2021',
    closingQuote: '“L’indifferenza è l’essenza della disumanità.”',
    footerText: 'Associazione impegnata per i diritti, l’autodeterminazione e la piena partecipazione delle persone con disabilità.',
    footerNav: 'Collegamenti finali',
    officialSite: 'Sito ufficiale',
    arengoPage: 'Pagina dell’Arengo',
    illuminatedStele: 'La stele illuminata',
    credits: 'Materiali fotografici e documentali: archivio Attiva-Mente.',
  },
  en: {
    pageTitle: 'Arengo — A living memory',
    skip: 'Skip to content',
    wordmarkLabel: 'Arengo — A living memory — back to the beginning',
    languageLabel: 'Website language',
    menuToggle: 'Open or close the menu',
    navLabel: 'Main navigation',
    nav: ['Story', 'Photographs', '12 requests', 'The journey', 'Archive'],
    accessibility: 'Accessibility',
    readingPreferences: 'Reading preferences',
    closeAccessibility: 'Close the accessibility panel',
    accessibilityIntro: 'Adapt the page to your needs. Your preferences remain on this device.',
    highContrast: 'High contrast',
    largeText: 'Larger text',
    reducedMotion: 'Reduce motion',
    active: 'On',
    inactive: 'Off',
    reset: 'Reset preferences',
    heroDate: '21 February 2021',
    heroTitleStart: 'This light',
    heroTitleMiddle: 'tells',
    heroTitleEnd: 'a story.',
    heroLead: 'The Arengo of families of persons with disabilities: a historic day, twelve requests, and a memorial stone that is visible once again.',
    enterStory: 'Enter the story',
    watchVideo: 'Watch the film',
    heroAlt: 'Citizens and families gathered in front of the Basilica of Saint Marinus for the Arengo on 21 February 2021',
    heroCaption: 'Piazzale Domus Plebis, 21 February 2021',
    scroll: 'Scroll to discover',
    chapterMemory: 'Memory',
    memory: 'The story',
    historyTitle: 'A page in the history of San Marino',
    historyLead: 'On 21 February 2021, families, associations and citizens gathered in Piazzale Domus Plebis to ask that recognised rights become rights experienced in everyday life.',
    whyArengo: 'Why call it an Arengo?',
    whyArengoText: 'The name recalls the Arengo of heads of households held on 25 March 1906, when a collective decision marked a democratic turning point for the Republic. In 2021, that name returned to affirm equality, participation and dignity.',
    pandemicLabel: 'During the pandemic',
    pandemicQuote: 'In lockdown for a lifetime',
    pandemicText: 'The Arengo took place in February 2021, during the COVID-19 emergency. Masks, distancing and restrictions made the value of that collective presence even more powerful.',
    pandemicNote: 'The words on a banner connected the pandemic present with the experience of exclusion that had begun long before.',
    historicNumbersLabel: 'Figures from the 1906 Arengo of heads of households',
    households: 'heads of households summoned',
    favourable: 'in favour',
    photoDate: '21 February 2021',
    photoTitle: 'A day\nwritten together.',
    photoLead: 'Faces, gestures and voices from the Arengo.',
    photoQuote: '“Encounter, enthusiasm, listening, participation and solidarity… we might call them excellent vaccines and antibodies against indifference.”',
    photoQuoteSource: 'From the speech by Attiva-Mente',
    explorePhotos: 'Explore the photographs',
    photoArchiveNote: 'Seven photographs selected from the original Attiva-Mente archive.',
    enlargePhoto: 'Enlarge photograph',
    closePhotos: 'Close the photo gallery',
    previousPhoto: 'Previous photograph',
    nextPhoto: 'Next photograph',
    photoArchive: 'Photographic archive',
    documentLabel: 'The document',
    requestsTitle: 'Twelve requests. One principle: equal dignity.',
    requestsLead: 'The document delivered to the Captains Regent translated participation into concrete commitments.',
    requestsIndex: 'Index of the twelve requests',
    previous: 'Previous',
    next: 'Next',
    of: 'of',
    previousRequest: 'Previous request',
    nextRequest: 'Next request',
    motto: '“Nothing about us without us.”',
    readOriginal: 'Read the original document',
    requestAlt: 'The Arengo memorial stone beside the flag of the Republic of San Marino',
    requestCaption: 'Participation becomes a concrete request.',
    timelineLabel: 'The memorial stone’s journey',
    timelineTitle: 'From voice to stone.\nFrom stone to light.',
    timeline2021Title: 'The Arengo',
    timeline2021Text: 'At the height of the COVID-19 pandemic, among masks and physical distancing, families, associations and citizens gathered before the Basilica to claim rights, participation and equal opportunities.',
    timeline2021Alt: 'The Arengo in front of the Basilica of Saint Marinus in 2021',
    timeline2023Title: 'The memorial finds a home',
    timeline2023Text: 'On 15 March, the memory of the Arengo found a permanent place, turning the remembrance of one day into a public landmark.',
    timeline2023Alt: 'The unveiling of the memorial stone in the rain in March 2023',
    timeline2026Title: 'A light is switched on',
    timeline2026Text: 'A spotlight finally makes the memorial stone visible after dark and restores dignity to the symbol.',
    timeline2026Link: 'Read about the new lighting',
    timeline2026Alt: 'The illuminated memorial stone at night in 2026',
    pressLabel: 'Pages from the time',
    pressTitle: 'The Arengo through the press.',
    pressLead: 'Eight records of the public attention generated by the initiative. Select a page to view it at full size; the articles are in Italian.',
    openEnlarge: 'Open and enlarge',
    explorePage: 'Explore the page',
    closePress: 'Close the press review',
    previousPage: 'Previous page',
    nextPage: 'Next page',
    openOriginal: 'Open the original',
    archiveLabel: 'Living archive',
    archiveTitle: 'Watch, listen, explore.',
    archiveLead: 'The Arengo lives on in the voices, images and documents of those who created it.',
    videoFallback: 'Your browser does not support this video.',
    videoLabel: 'The film',
    videoTitle: 'Arengo of families of persons with disabilities',
    transcriptTitle: 'Context and summary of the initiative',
    transcript1: 'The initiative opens with greetings from the organisers and contributions from participating organisations, continues with the celebration inside the Basilica, and concludes with the reading of the twelve requests, musical accompaniment and the unveiling of the memorial stone.',
    transcript2: 'Its central message is clear: recognised rights must become fully enforceable, with persons with disabilities directly involved in decisions that concern them.',
    originalDocuments: 'Original documents',
    originalItalian: 'original in Italian',
    pressArchiveLabel: 'Press review',
    pressArchiveTitle: 'The pages that recorded the Arengo',
    pressImageAlt: 'La Serenissima page of 22 February 2021 dedicated to the Arengo',
    pressPdf: 'Open the La Serenissima PDF',
    closingLabel: 'A memory that remains visible',
    closingTitle: 'Rights must never remain in the shadows.',
    closingLead: 'Lighting this memorial stone means safeguarding the memory of the Arengo, the families and a community that chose to participate.',
    closingLine: 'Even a light can tell a story.',
    discover: 'Discover Attiva-Mente',
    backTop: 'Back to the beginning',
    thanks: 'Thank you to everyone who made the light possible, and to all those who continue to defend this memory.',
    closingAlt: 'The community gathered before the Basilica of Saint Marinus with the banner against indifference',
    closingCaption: 'The community before the Basilica, 21 February 2021',
    closingQuote: '“Indifference is the essence of inhumanity.”',
    footerText: 'An association committed to the rights, self-determination and full participation of persons with disabilities.',
    footerNav: 'Final links',
    officialSite: 'Official website',
    arengoPage: 'The Arengo page',
    illuminatedStele: 'The illuminated memorial',
    credits: 'Photographic and documentary materials: Attiva-Mente archive.',
  },
}

export const englishRequests = [
  { short: 'UN Convention', title: 'Implement the Convention', text: 'Implement the UN Convention on the Rights of Persons with Disabilities by enforcing the laws already in force and adopting the legislative measures that are still missing.' },
  { short: 'Participation', title: 'Nothing about us without us', text: 'Involve persons with disabilities in the decisions that concern them, putting the Convention’s principle “Nothing about us without us” into practice.' },
  { short: 'Life projects', title: 'Build life projects together', text: 'Establish stable and continuous cooperation between services, families, voluntary associations and cooperatives in shaping each person’s life project and supporting their transition into adulthood.' },
  { short: 'UN Commission', title: 'Strengthen the Commission', text: 'Strengthen and consolidate the role of San Marino’s Commission for implementing the UN Convention on the Rights of Persons with Disabilities, giving it greater powers and resources.' },
  { short: 'School and work', title: 'From school to work', text: 'Quickly establish a working group to identify solutions to the urgent issues facing persons with disabilities after school age and address the remaining gaps in education and employment inclusion.' },
  { short: 'Long-term support', title: 'A plan for people requiring support', text: 'Create a plan for people who are not self-sufficient, including urgently needed social-care models — caregivers and personal assistants — together with rules on Independent Living and support after parents are no longer able to provide care, ensuring freedom and dignity for persons with disabilities and peace of mind for their families.' },
  { short: 'Single access point', title: 'One place for services and information', text: 'Create a single place to handle procedures and provide all the information needed by persons with disabilities and their families, as envisaged by Article 10 of Delegated Decree no. 14 of 1 February 2018.' },
  { short: 'Aids and prostheses', title: 'Update the official catalogue', text: 'Update and publish the official catalogue so it reflects the needs of every person with a disability — including those with the greatest support needs — and rapid technological progress, as envisaged by Article 7(3b) of Delegated Decree no. 14 of 1 February 2018.' },
  { short: 'Remove barriers', title: 'Remove every barrier', text: 'Remove the obstacles to full participation in social and political life, beginning with architectural, communication, digital and bureaucratic barriers.' },
  { short: 'Non-discrimination', title: 'Respect every difference', text: 'Respect the personal and cultural diversity of all persons with disabilities, without exception and without discrimination.' },
  { short: 'Data and inclusion', title: 'Understand in order to include', text: 'Launch a statistical study that goes beyond health data and provides the information needed to understand and assess the true level of participation and inclusion of persons with disabilities.' },
  { short: 'Resources and equity', title: 'Allocate resources fairly', text: 'Conduct an in-depth study of the quantity and quality of the financial and human resources made available by the State for disability, and reconsider their allocation on an equitable basis.' },
]

export const englishDocuments = [
  'Document delivered to the Captains Regent',
  'Speech by Attiva-Mente',
  'Address by Bishop Andrea Turazzi',
  'Press release',
]

export const englishPhotoEssay = [
  ['Being present', 'Participants at the Arengo wearing masks, including a wheelchair user, gathered in Piazzale Domus Plebis'],
  ['Music accompanies the voices', 'Violinist Akiko Yatani performs during the Arengo, wearing a mask decorated with the coat of arms of San Marino'],
  ['The community before the Basilica', 'The community gathered before the Basilica of Saint Marinus and the long banner against indifference'],
  ['Piazzale Domus Plebis', 'A view from above of people physically distanced in Piazzale Domus Plebis during the Arengo'],
  ['A message against indifference', 'The banner reading Indifference is the essence of inhumanity before the Basilica of Saint Marinus'],
  ['The signing', 'The message of the Arengo is signed at the entrance to the Basilica of Saint Marinus'],
  ['The memorial stone and the flag', 'The Arengo memorial stone beside the flag of the Republic of San Marino'],
]

export const englishPressTitles = [
  'Persons with disabilities and families in the square: “Enough discrimination”',
  'Inclusion and assistance: the requests to the Captains Regent',
  'CSdL: “The right to work must be guaranteed for persons with disabilities”',
  'A page that will remain in San Marino’s history',
  'The families’ Arengo: “a historic page”',
  'The families’ Arengo, a page that will remain in history',
  'The families’ Arengo message to the Regency',
  'Attiva-Mente promotes the Arengo of families of persons with disabilities',
]
